import { Inject, Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { APP_STORE_CONFIG_TOKEN, ErrorDCR } from '@ddt-web/config';
import { AppStoreConfig } from '@ddt-web/data-service';
import { PartnerInitService, PartnerPortfolioDataService } from '@ddt-web/partner-integrations';
import { StoreService } from '@ddt-web/store-service';
import { PartnerUserProfileService } from '@ddt-web/user-data';
import * as castArray from 'lodash/castArray';
import * as get from 'lodash/get';
import * as isEmpty from 'lodash/isEmpty';
import { combineLatest } from 'rxjs';
import { first } from 'rxjs/operators';

import { AbstractWorker } from '../models/abstract-worker';
import { PortfolioResolverUtil } from '../utils/portfolio-resolver.util';


@Injectable()
export class PartnerPortfolioResolverWorker extends AbstractWorker {

	constructor(
		private partnerPortfolioDataService: PartnerPortfolioDataService,
		public storeService: StoreService,
		private contentService: ContentService,
		private partnerUserProfileService: PartnerUserProfileService,
		@Inject(APP_STORE_CONFIG_TOKEN) public storeConfig: AppStoreConfig,
		private partnerInitService: PartnerInitService
	) {
		super();
	}

	public handle(queryParams: any): any {
		const ids = castArray(get(queryParams, 'portfolios', []));
		const shouldReimport = get(queryParams, 'reimport') === 'true';

		if (!isEmpty(ids)) {
			this.setupPartnerPortfolios(ids, shouldReimport);
		}
	}

	private setupPartnerPortfolios(ids: any[], shouldReimport: boolean): void {
		this.partnerInitService.initWithPortfolioId(this.storeConfig);

		combineLatest(
			this.partnerUserProfileService.getPartner(),
			this.storeService.selectAll(this.storeConfig.modelsConfig),
			this.storeService.selectByIds(this.storeConfig.associatedPortfolios, ids)
		).pipe(
			first(([partner, config, associatedPortfolios]) => config && !config.isLoading && !associatedPortfolios.isLoading)
		).subscribe(([partner, config, associatedPortfolios]) => {
			const configEntities = config.entities;
			if (isEmpty(configEntities)) {
				throw new Error('Critical configuration is missing');
			}
			const partnerPortfolios = PortfolioResolverUtil.extractPartnerPortfolioIds(ids);
			const partnerPortsMissingData = partnerPortfolios.filter(id => !configEntities[id] && !associatedPortfolios.entities[id]);
			// If we have external portfolios missing data then get them from api
			if (!isEmpty(partnerPortsMissingData)) {
				if (partner) {
					this.storeService.fetch(this.storeConfig.associatedPortfolios);
					this.partnerPortfolioDataService.fetchExternalModel(this.storeConfig.associatedPortfolios, partner, partnerPortsMissingData, shouldReimport);
				} else {
					throw new Error(this.contentService.get('PARTNER_UNAUTHORISED_PORTFOLIO_ACCESS', ErrorDCR.PARTNER_UNAUTHORISED_PORTFOLIO_ACCESS));
				}
			}
		});
	}

}
